import { LabelGenerator } from '../../types';

export const isFlexgeld: LabelGenerator = (product) =>
  product.product_type === 'TERM' &&
  product.conditions.termination.contractual_termination_allowed &&
  'Flexgeld';
